export const DATABASE_UNAVAILABLE_ERROR_CODE = 'DATABASE_UNAVAILABLE';
export const DATABASE_UNAVAILABLE_ERROR_MESSAGE =
  'Database temporarily unavailable. Please retry.';
